import { getDistance, toObject } from '@m1/geo-utils';
import { degreesToRadians } from '@turf/turf';
import commaNumber from 'comma-number';
import { Point } from 'ol/geom';
import { toLonLat } from 'ol/proj';
import { Style, Fill, Stroke, Text } from 'ol/style';

const calculateRotation = (from, to) => {
  const adjacent = Math.abs(to.lat - from.lat); // 밑변
  const opposite = Math.abs(to.lng - from.lng); // 높이

  let degree = (Math.atan2(adjacent, opposite) * 180) / Math.PI;
  degree += 5; // 미세 보정
  if (
    (from.lat < to.lat && from.lng < to.lng) || // 우상향
    (from.lat > to.lat && from.lng > to.lng) // 좌하향
  ) {
    degree *= -1;
  }

  return degreesToRadians(degree);
};

export const createDistanceLabelStyles = (geometry) => {
  const styles = [];

  const coords = geometry.getCoordinates();
  for (let index = 1; index < coords.length - 1; index++) {
    const fromCoord = coords[index];
    const toCoord = coords[index + 1];

    const from = toObject(toLonLat(fromCoord));
    const to = toObject(toLonLat(toCoord));

    const distance = getDistance(from, to);
    const rotation = calculateRotation(from, to);
    const midPoint = [(fromCoord[0] + toCoord[0]) / 2, (fromCoord[1] + toCoord[1]) / 2];

    styles.push(
      new Style({
        geometry: new Point(midPoint),
        text: new Text({
          text: `${commaNumber(distance.toFixed(1))}m`,
          font: '12px "Noto Sans KR", sans-serif',
          fill: new Fill({ color: 'white' }),
          stroke: new Stroke({ color: 'black', width: 4 }),
          rotation,
        }),
      }),
    );
  }

  return styles;
};
